import { PracticeContentDataFields } from '@cibo/core'
import { createContext, PropsWithChildren, useContext, useState } from 'react'
import { PracticeRequirementModal } from './PracticeRequirementModal'
import { PracticeRequirementModalState } from './PracticeRequirementModalTypes'

export interface PracticeRequirementModalContextType {
  modalState: PracticeRequirementModalState
  setModalState: (state: PracticeRequirementModalState) => void
}

export const DEFAULT_VALUES = {
  modalState: {
    open: false,
    practice: undefined,
    onClickSelect: (practiceId: string) =>
      console.log('PracticeRequirementModalContext onClickSelect is not defined', practiceId),
  },
  setModalState: () => {},
}

export const PracticeRequirementModalContext =
  createContext<PracticeRequirementModalContextType>(DEFAULT_VALUES)
PracticeRequirementModalContext.displayName = 'PracticeRequirementModalContext'

export const usePracticeRequirementModal = () => useContext(PracticeRequirementModalContext)

export const PracticeRequirementModalProvider = ({ children }: PropsWithChildren) => {
  const [modalState, setModalState] = useState<PracticeRequirementModalState>(
    DEFAULT_VALUES.modalState
  )
  const setModalStateFunct = setModalState as (state: {
    open: boolean
    practice?: PracticeContentDataFields
    onClickSelect: (practiceId: string) => void
  }) => void

  return (
    <PracticeRequirementModalContext.Provider
      value={{
        ...DEFAULT_VALUES,
        modalState,
        setModalState: setModalStateFunct,
      }}
    >
      {children}
      <PracticeRequirementModal
        modalState={modalState}
        setModalState={setModalState}
        onClickSelect={() =>
          modalState.practice?.fields.practiceId &&
          !!modalState.onClickSelect &&
          modalState.onClickSelect?.(modalState.practice?.fields.practiceId)
        }
      />
    </PracticeRequirementModalContext.Provider>
  )
}
